import { Component, ViewChild } from "@angular/core";
import {
  NavController,
  NavParams,
  ViewController,
  Content
} from "ionic-angular";
import { Store } from "@ngrx/store";
import { FannelPage } from "../fannel/fannel";
import { GeneralPaginService } from "../../services/general.pagin.service";
import * as firebase from "firebase";

import { AppState } from "../../app/app.reducer";
import { Idol, Token } from "../../app/app.models";
import { ConfigService } from "../../services/config.service";
import { AppUtilities } from "../../app/app.utilities";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "page-idolprofile",
  templateUrl: "idolprofile.html"
})
export class IdolprofilePage {
  public idol$: Idol;
  public tokens$: Token[] = [];
  moreAssets: boolean;
  public refresh;
  showWatacards: boolean = false;
  @ViewChild(Content)
  content: Content;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public store: Store<AppState>,
    private generalPaginService: GeneralPaginService,
    private configService: ConfigService,
    public viewCtrl: ViewController,
    private utilities: AppUtilities,
    private translate: TranslateService
  ) {
    this.idol$ = navParams.data;
    this.showWatacards = false;
    console.log("IDOL : ", this.idol$, "uid ", this.idol$.uid);
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad IdolprofilePage");
  }

  ionViewWillEnter() {}

  loadMoreAssets($event) {
    if (this.content.directionY == "down" && this.moreAssets) {
      console.log("Event ", $event);
      var idiom = this.configService.getIdiom();
      if (idiom == "en") this.utilities.loading("Checking Blockchain");

      if (idiom == "es") this.utilities.loading("Consultando Blockchain");
      setTimeout(() => {
        this.generalPaginService.getBlockAssets().then(assets => {
          if (assets.length > 0) {
            for (let asset of assets) {
              this.tokens$.push(asset);
            }
            this.moreAssets = this.generalPaginService.getMoreAssets();
          } else {
            this.moreAssets = this.generalPaginService.getMoreAssets();
          }
          this.utilities.loadingDismiss();
          $event.complete();
        });
      }, 1000);
    } else {
      $event.complete();
    }
  }
  doRefresh($event) {
    this.refresh = $event;
    this.utilities.loading("Consultando Blockchain");
    this.generalPaginService
      .getAssetsIdsIssuedBy(this.idol$.address)
      .then((assets: any[]) => {
        this.utilities.loadingDismiss();
        if (assets) {
          if (assets.length > 0) {
            this.moreAssets = this.generalPaginService.getMoreAssets();
            this.tokens$ = assets;
          } else {
            this.moreAssets = false;
          }
        }
        $event.complete();
      });
  }

  goFannel() {
    this.navCtrl.push(FannelPage, { idol: this.idol$ });
  }

  loadAssets() {
    this.showWatacards = true;
    var idiom = this.configService.getIdiom();
    if (idiom == "en") this.utilities.loading("Checking Blockchain");

    if (idiom == "es") this.utilities.loading("Consultando Blockchain");
    this.generalPaginService
      .getAssetsIdsIssuedBy(this.idol$.address)
      .then((assets: any[]) => {
        this.utilities.loadingDismiss();
        if (assets) {
          console.log("Assets " + assets.length);
          if (assets.length > 0) {
            this.moreAssets = this.generalPaginService.getMoreAssets();
            this.tokens$ = assets;
          } else {
            this.moreAssets = false;
            this.showWatacards = false;
          }
        }
      });
  }

  animateIdol() {
    var star;

    firebase
      .database()
      .ref("/prod_idols/" + this.idol$.uid)
      .once("value")
      .then((snapshot: any) => {
        var idol = snapshot.val();
        star = idol.star;
        star = star + 1;
        this.idol$.star = star;

        firebase
          .database()
          .ref("/prod_idols/" + this.idol$.uid)
          .update({ star: star });
      });
  }

  openModal() {
    var soon = this.translate.instant("SOON");
    this.utilities.alert(soon);
  }

  goFaceboock() {
    if (this.idol$.facebookUrl) {
      var url = this.idol$.facebookUrl;
      if (url != "#") window.open(url, "_system");
    }
  }

  goTwitter() {
    if (this.idol$.twitterUrl) {
      var url = this.idol$.twitterUrl;
      if (url != "#") window.open(url, "_system");
    }
  }

  goInstagram() {
    if (this.idol$.instagramUrl) {
      var url = this.idol$.instagramUrl;
      if (url != "#") window.open(url, "_system");
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/idolprofile/idolprofile.ts